import React from "react";
import NavTagline from "../nav-tagline/nav-tagline";
import PortalLg from "../../assets/images/portal-logo-large.png";
import { Link } from "react-router-dom";
import Footer from "../shared/Footer";

const SignOut = () => {
  return (
    <div className="SignOut">
      <NavTagline />
      <section class="layout-container">
        <div className="container ctr">
          <div className="sp-margin6 animate slide delay-1">
            <img
              src={PortalLg}
              className="filter-blue w-md2"
              alt="Signed Out Icon"
            />
          </div>
          <div className="sign-out-wrapper animate slide delay-2">
            Signed Out
          </div>
          <div className="text-size6 spacer-margin3 animate slide delay-3">
            You have successfully logged out.
          </div>
          <Link
            to={"/"}
            className="btn btn-primary animate slide delay-4"
            role="button"
            aria-labelledby="Continue to Login"
          >
            Back to Portal
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};


export default SignOut;
